import './PreventiveReportCreate.scss';

import { useMemo } from "react";

import { useSurveyCreateForm } from "../../../hooks/useSurveyCreateForm";
import { useGetSurveyFieldOptions } from "../../../hooks/useGetSurveyFieldOptions";

import { Field } from "../../../common-components/Field/Field";

const PreventiveReportCreate = () => {
    const { formId, adaptedFieldList } = useSurveyCreateForm();

    useGetSurveyFieldOptions();

    const memoizedFieldList = useMemo(() => {
        return adaptedFieldList.map(category => ({
            ...category,
            fields: category.fields.map(field => {
                const isStaticOptions = Array.isArray(field.options);

                console.log("Fields in category:", category.fields);

                return {
                    ...field,
                    options: isStaticOptions ? field.options : field.options,
                    optionsUrl: isStaticOptions ? undefined : field.options
                };
            })
        }));
    }, [adaptedFieldList]);

    console.log(adaptedFieldList);

    console.log("memoizedFieldList", memoizedFieldList);

    return (
        <div className={"preventive_report_create"}>
            <div className={"preventive_report_create_container"}>
                <div className={"preventive_report_create_form"}>
                    {memoizedFieldList.map((category) => (
                        <div className={"preventive_report_create_form_category"} key={category.category}>
                            <div className={"preventive_report_create_form_category_title"}>
                                {category.category}
                                <div className={"preventive_report_create_form_category_attention"}>
                                    {category.categoryAttention}
                                </div>
                            </div>
                            <div className={"preventive_report_create_form_category_items"}>
                                {category.fields
                                    .filter((f) => !f.isVirtualSubfield)
                                    .map((field) => (
                                        <Field
                                            key={field.name}
                                            label={field.label}
                                            name={field.name}
                                            propertyLabel={field.label}
                                            options={field.options}
                                            formId={formId}
                                            type={field.type}
                                            validationRules={field.validationRules}
                                            fieldStructure={field.fieldStructure}
                                        />
                                    ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default PreventiveReportCreate;